<template lang="html">
    <div class="calendar">
        <div class="calendar-ctrls">
            <div class="calendar-ctrls__prev" v-if="prevMonthAvailable" @click="prevMonth"><i class="fa fa-chevron-left"></i></div>
            <div class="calendar-ctrls__current">{{ currentMonthName + ' ' + currentYear }}</div>
            <div class="calendar-ctrls__next" v-if="nextMonthAvailable" @click="nextMonth"><i class="fa fa-chevron-right"></i></div>
        </div>

        <table class="table table-bordered">
            <thead>
                <tr>
                    <th>MON</th>
                    <th>TUE</th>
                    <th>WED</th>
                    <th>THU</th>
                    <th>FRI</th>
                    <th>SUN</th>
                    <th>SAT</th>
                </tr>
            </thead>
            <tbody>
                
            </tbody>
        </table>

        <div class="calendar-legends">
            <div class="calendar-legends__item">
                <span class="calendar-legends__color _white"></span> - Available
            </div>
            <div class="calendar-legends__item">
                <span class="calendar-legends__color _gray"></span> - Unavailable
            </div>
            <div class="calendar-legends__item">
                <span class="calendar-legends__color _yellow"></span> - Your reservation
            </div>
            <div class="calendar-legends__item">
                <span class="calendar-legends__color _green"></span> - Selected
            </div>
        </div>

        <div class="calendar__choosen-date"></div>

        <div id="calendar-approve" tabindex="-1" role="dialog" class="modal fade">
            <div role="document" class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Selected date range:</h4>
                    </div> 
                    <div class="modal-body text-center">
                        <span class="date-from"></span> - <span class="date-to"></span>
                    </div> 
                    <div class="modal-footer">
                        <button type="button" class="big-purple-button">Proceed</button>
                        <button type="button" data-dismiss="modal" class="btn btn-default">Edit date</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// Calendar component for talent pool reservation
export default {
  props: ['closedDates', 'reservedDates', 'maxDate', 'openedDate'],
  data() {
    return {
      todayMonthNum: null,
      todayYear: null,
      currentMonthNum: null,
      currentYear: null,
      monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
      preReservedDates: null              
    };
  },
  computed: {
    closedDatesParsed: function(){
      if(this.closedDates && _.isString(this.closedDates)){
        return JSON.parse(this.closedDates);
      } else {
        return false;
      }
    },
    reservedDatesParsed: function(){
      if(this.reservedDates && _.isString(this.reservedDates)){
        return JSON.parse(this.reservedDates);
      } else {
        return false;
      }
    },
    // Get month name from month number
    currentMonthName: function(){
      return this.monthNames[this.currentMonthNum];
    },
    // Is previous month available or note
    prevMonthAvailable: function(){
      if(!this.todayMonthNum || !this.todayYear || !this.currentMonthNum || !this.currentYear) return true;

      if(this.todayMonthNum >= this.currentMonthNum && this.todayYear >= this.currentYear){
        return false;
      } else {
        return true;
      }
    },
    // Is previous month available or note
    nextMonthAvailable: function(){
      let maxDateObj = new Date(this.maxDate);

      if(maxDateObj.getMonth() <= this.currentMonthNum && maxDateObj.getFullYear() <= this.currentYear){
        return false;
      } else {
        return true;
      }
    },
  },
  methods: {
    // Parse date number to always show with 2 digits: 01, 09, 23
    dayParse: function(num){
      if(num >= 10){
        return num;
      } else {
        return '0' + num;
      }
    },
    // Get previus month number
    prevMonth: function(){
      if(this.currentMonthNum == 0){
        this.currentMonthNum = 11;
        this.currentYear -= 1;
      } else {
        this.currentMonthNum -= 1;
      }
      this.buildCalendar(this.currentYear, this.currentMonthNum);
    },
    // Get next month number
    nextMonth: function(){
      if(this.currentMonthNum == 11){
        this.currentMonthNum = 0;
        this.currentYear += 1;
      } else {
        this.currentMonthNum += 1;
      }
      this.buildCalendar(this.currentYear, this.currentMonthNum);
    },
    // Approve dates of reservation
    approveReserve: function(startDate, endDate){
      var self = this;
      $('#calendar-approve .modal-body span.date-from').html(startDate);
      $('#calendar-approve .modal-body span.date-to').html(endDate);
      $('#calendar-approve').modal('show');

      $(document).on('click', '#calendar-approve .modal-footer .big-purple-button', function(){
        $('.calendar__choosen-date').html('Selected date: ' + startDate + ' - ' + endDate);
        $('#create-talent-pool-record input[name="date"]').val(startDate + '/' + endDate);
        $(`.calendar table td[data-date="${startDate}"]`).addClass('pre-reserved');
        $(`.calendar table td[data-date="${startDate}"]`).siblings().addClass('pre-reserved');
        $('#calendar-approve').modal('hide');
        $('.talent-pool__form-wrap').show();
        self.drawPreReserved(startDate, endDate);
      });
    },
    // Get day from full date
    getDay: function(date){
      var day = date.getDay();
      if (day == 0) day = 7;
      return day - 1;
    },
    // Change color of days which have already reserved by another users
    drawClosedWeeks: function(){
      if(!_.isArray(this.closedDatesParsed) || this.closedDatesParsed.length == 0){
        return false;
      }
      let closedMondays = this.closedDatesParsed.map(function(item){
        let separateIndex = item.indexOf("/");
        return item.substr(0, separateIndex);
      });
      $('.calendar table tbody tr').each(function(){
        let cellDate = $(this).find('td:first').data('date');
        let results = _.find(closedMondays, function(item){
          return cellDate == item;
        });
        if(results){
          $(this).find('td').addClass('closed');
        }
      });
    },
    // Change color of days which have already reserved by this user
    drawReservedWeeks: function(){
      if(!_.isArray(this.reservedDatesParsed) || this.reservedDatesParsed.length == 0){
        return false;
      }
      let closedMondays = this.reservedDatesParsed.map(function(item){
        let separateIndex = item.indexOf("/");
        return item.substr(0, separateIndex);
      });
      $('.calendar table tbody tr').each(function(){
        let cellDate = $(this).find('td:first').data('date');
        let results = _.find(closedMondays, function(item){
          return cellDate == item;
        });
        if(results){
          $(this).find('td').addClass('reserved');
        }
      });
    },
    // Change color of days which is out of expiry date range
    drawOutExpiry: function(){
      if(!this.maxDate) return false;
      let maxDateObj = new Date(this.maxDate);
      let expiryDateCell = $(`.calendar table tr td[data-date="${this.maxDate}"]`);

      if(maxDateObj.getMonth() < this.currentMonthNum && maxDateObj.getFullYear() <= this.currentYear){
        $('.calendar table tr td').addClass('closed');
        return false;
      } else if(maxDateObj.getMonth() <= this.currentMonthNum && maxDateObj.getFullYear() < this.currentYear){
        $('.calendar table tr td').addClass('closed');
        return false;
      }

      if(expiryDateCell.length == 0) {
        return false;
      } else {
        expiryDateCell.addClass('closed');
        expiryDateCell.siblings().addClass('closed');
        expiryDateCell.parent('tr').nextAll('tr').find('td').addClass('closed');
      }
    },
    // Change color of days which user select
    drawPreReserved: function(startDate, endDate){
      if(startDate && endDate){
        this.preReservedDates = startDate+'/'+endDate;
      }
      if(!this.preReservedDates) return false;
      $('.calendar table tbody td.pre-reserved').removeClass('pre-reserved');

      let mondayPreReservedDate = this.preReservedDates.substr(0, this.preReservedDates.indexOf('/'));
      $('.calendar table tbody tr').each(function(){
        let cellDate = $(this).find('td:first').data('date');

        if(cellDate == mondayPreReservedDate){
          $(this).find('td').addClass('pre-reserved');
        }
      });
    },
    // build calendar in DOM
    buildCalendar: function(year, month){
      var elem = $(this.$el).find('tbody')[0];
      var mon = month;
      var d = new Date(year, mon);
      var today = new Date();
      var prevDay = new Date(year, mon);
      var prevDays = [];
      var table = '';

      for(var i = 0; i < this.getDay(d); i++){
        prevDay.setDate(prevDay.getDate()-1);
        prevDays.push(prevDay.getDate());
      }
      prevDays.reverse();
      for(var i = 0; i < prevDays.length; i++){
        let attr = this.dayParse(mon) + '-' + this.dayParse(prevDays[i]) + '-' + year;
        table += `<td class="out" data-date="${attr}">${prevDays[i]}</td>`;
      }

      while (d.getMonth() == mon) {
        let attr = this.dayParse(mon+1) + '-' + this.dayParse(d.getDate()) + '-' + year;
        table += `<td data-date="${attr}">${d.getDate()}</td>`;

        if (this.getDay(d) % 7 == 6) {
          table += '</tr><tr>';
        }

        d.setDate(d.getDate() + 1);
      }

      if (this.getDay(d) != 0) {
        let dayAfter = 1;
        for (var i = this.getDay(d); i < 7; i++) {
          let attr = this.dayParse(mon+2) + '-' + this.dayParse(dayAfter) + '-' + year;
          table += `<td class="out" data-date="${attr}">${dayAfter}</td>`;
          dayAfter++;
        }
      }

      elem.innerHTML = table;

      var calendarsWeeks = $(elem).find('tr');
      for(i = 0; i < calendarsWeeks.length; i++){
        let day = new Date($(calendarsWeeks[i]).find('td:first').data('date'));
        if(day.getMonth() < today.getMonth() && day.getYear() == today.getYear()){
          $(calendarsWeeks[i]).find('td').addClass('closed');
        } else if(day.getMonth() == today.getMonth() && day.getDate() <= today.getDate()){
          $(calendarsWeeks[i]).find('td').addClass('closed');
        }
      }

      this.drawClosedWeeks();
      this.drawReservedWeeks();
      this.drawOutExpiry();
      this.drawPreReserved();
    },
  },
  mounted() {
    var self = this;
    let todayDate = new Date();
    let currentDate;

    if(this.openedDate){
      currentDate = new Date(this.openedDate);
    } else {
      currentDate = new Date();
    }

    this.currentYear = currentDate.getFullYear();
    this.currentMonthNum = currentDate.getMonth();
    this.todayMonthNum = todayDate.getMonth();
    this.todayYear = todayDate.getFullYear();

    this.buildCalendar(this.currentYear, this.currentMonthNum);

    // Click event for free dates
    $(document).on('click', '.calendar table tr', function(){
      if($(this).find('td.closed').length == 0 && $(this).find('td.reserved').length == 0 && $(this).find('td.pre-reserved').length == 0){
        let startDate = $(this).find('td').first().data('date');
        let endDate = $(this).find('td').last().data('date');
                    
        self.approveReserve(startDate, endDate);
      }
    });
  }
};
</script>

<style lang="scss">
    .calendar {
        margin: 20px 0;
        
        table {
            width: 80%;
            margin: 0 auto;
            border: 0;

            &>thead>tr>th {
                border: 0;
                text-align: center;
                font-weight: 600;
            }

            tbody tr:hover td {
                background: #EFEFEF;
            }

            td {
                height: 50px;
                background: #fff;
                text-align: right;
                color: #333;

                &.out {
                    opacity: 0.5;
                }
                &.closed {
                    background: #c0c0c0 !important;
                    color: #000000;
                }
                &.pre-reserved {
                    background: #bbfeae;
                    color: #333;
                }
                &.reserved {
                    background: #ffe6be !important;
                    color: #ffa000;
                }
            }
        }
    }

    .calendar-legends {
        margin: 10px 10% 20px;
    }
    .calendar-legends__color {
        display: inline-block;
        border: 2px solid #777;
        height: 20px;
        width: 40px;
        vertical-align: middle;

        &._white { background-color: #ffffff; }
        &._gray { background-color: #c0c0c0; }
        &._yellow { background-color: #ffe6be; }
        &._green { background-color: #bbfeae; }
    }

    .calendar-ctrls {
        text-align: center;

        &__prev,
        &__next {
            display: inline-block;
            color: #999;
            cursor: pointer;
        }
        &__current {
            display: inline-block;
            margin: 0 10px;
            font-weight: 600;
        }
    }

    #calendar-approve .modal-body span { font-weight: bold; }

    .calendar__choosen-date {
        margin: 10px 10% 20px;
        font-weight: bold;
    }
</style>